function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_146",
  "data-name": "Group 146",
  transform: "translate(11.669)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_145",
  "data-name": "Group 145"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M158.445,19.07a6.675,6.675,0,0,0-4.4-2.658,6.842,6.842,0,0,0-1.072-.076H141.825V9.052A9.062,9.062,0,0,0,132.773,0,2.051,2.051,0,0,0,130.9,1.218l-9.335,21a2.052,2.052,0,0,0-.177.833V48.725a2.051,2.051,0,0,0,2.051,2.051h26.377a6.719,6.719,0,0,0,6.642-5.708l3.221-21.006A6.675,6.675,0,0,0,158.445,19.07Zm-2.823,4.374L152.4,44.45a2.628,2.628,0,0,1-2.587,2.224H125.489V23.49l8.544-19.225a4.959,4.959,0,0,1,3.689,4.787v9.335a2.051,2.051,0,0,0,2.051,2.051h13.232a2.667,2.667,0,0,1,.422.029,2.616,2.616,0,0,1,2.194,2.976Z",
  transform: "translate(-121.387 0)",
  fill: "#868eae"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_148",
  "data-name": "Group 148",
  transform: "translate(0 21.003)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_147",
  "data-name": "Group 147"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M17.448,237.456h-7A2.619,2.619,0,0,1,7.83,234.84V218.5a2.619,2.619,0,0,1,2.616-2.616h7a2.051,2.051,0,0,0,0-4.1h-7A6.726,6.726,0,0,0,3.728,218.5V234.84a6.726,6.726,0,0,0,6.719,6.719h7a2.051,2.051,0,0,0,0-4.1Z",
  transform: "translate(-3.728 -211.786)",
  fill: "#868eae"
})));

var Svg024Like = function Svg024Like(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_024-like",
    "data-name": "024-like",
    width: 50.037,
    height: 50.776,
    viewBox: "0 0 50.037 50.776",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg024Like, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/024-like.ecda8fcb.svg";
export { ForwardRef as ReactComponent };